import timeZoneData from 'dashboard/routes/dashboard/settings/inbox/helpers/timezones.json';

// Fusos que aparecem primeiro, com nome em português (a busca acha "Lisboa"
// e "Lisbon"). O resto do mundo vem depois, em ordem de GMT. Pedido de
// cliente em Portugal (14/10): a lista só tinha o Brasil.
const FEATURED = {
  'America/Sao_Paulo': 'Brasil — Brasília, São Paulo, Sul e Sudeste',
  'America/Bahia': 'Brasil — Bahia',
  'America/Fortaleza': 'Brasil — Fortaleza, CE, RN, PB, PI, MA',
  'America/Recife': 'Brasil — Recife, Pernambuco',
  'America/Maceio': 'Brasil — Maceió, Alagoas, Sergipe',
  'America/Belem': 'Brasil — Belém, Pará, Amapá',
  'America/Santarem': 'Brasil — Santarém, oeste do Pará',
  'America/Araguaina': 'Brasil — Tocantins',
  'America/Cuiaba': 'Brasil — Cuiabá, Mato Grosso',
  'America/Campo_Grande': 'Brasil — Campo Grande, Mato Grosso do Sul',
  'America/Manaus': 'Brasil — Manaus, Amazonas',
  'America/Porto_Velho': 'Brasil — Porto Velho, Rondônia',
  'America/Boa_Vista': 'Brasil — Boa Vista, Roraima',
  'America/Rio_Branco': 'Brasil — Rio Branco, Acre',
  'America/Noronha': 'Brasil — Fernando de Noronha',
  'Europe/Lisbon': 'Portugal — Lisboa (Lisbon)',
  'Atlantic/Madeira': 'Portugal — Madeira',
  'Atlantic/Azores': 'Portugal — Açores (Azores)',
};

const allZones = () => {
  if (typeof Intl.supportedValuesOf === 'function') {
    return Intl.supportedValuesOf('timeZone');
  }
  return Object.values(timeZoneData);
};

// "GMT-03:00" no instante `now` — já reflete horário de verão.
export const formatGmtOffset = (timeZone, now = new Date()) => {
  try {
    const part = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'longOffset',
    })
      .formatToParts(now)
      .find(item => item.type === 'timeZoneName');
    const offset = part?.value || 'GMT';
    return offset === 'GMT' ? 'GMT+00:00' : offset;
  } catch {
    return '';
  }
};

const offsetMinutes = offset => {
  const match = /GMT([+-])(\d{2}):(\d{2})/.exec(offset);
  if (!match) return 0;
  const minutes = Number(match[2]) * 60 + Number(match[3]);
  return match[1] === '-' ? -minutes : minutes;
};

const toOption = (value, now) => {
  const offset = formatGmtOffset(value, now);
  const name = FEATURED[value] || value.replace(/_/g, ' ');
  return {
    value,
    label: offset ? `${name} (${offset})` : name,
    offset,
  };
};

// Opções de fuso para select/combobox: { value: 'Europe/Lisbon', label }.
// `current` garante que o fuso já salvo continue aparecendo.
export const timezoneOptions = ({ now = new Date(), current = '' } = {}) => {
  const featured = Object.keys(FEATURED).map(value => toOption(value, now));
  const rest = [...new Set([...allZones(), current].filter(Boolean))]
    .filter(value => !FEATURED[value])
    .map(value => toOption(value, now))
    .sort(
      (a, b) =>
        offsetMinutes(a.offset) - offsetMinutes(b.offset) ||
        a.value.localeCompare(b.value)
    );

  return [...featured, ...rest].map(({ value, label }) => ({ value, label }));
};
